import * as app from '@app/models';
import { PropertyDetail, DwellingTypeCode } from '@apis/models';

export function getTypeOfResidence(propertyDetail: PropertyDetail): app.ResidenceType {
  if (propertyDetail.attributes.dwellingType) {
    switch (propertyDetail.attributes.dwellingType) {
      case DwellingTypeCode.SingleFamilyResidence:
        return app.ResidenceType.SingleFamilyResidence;
      case DwellingTypeCode.Condominium:
        return app.ResidenceType.Condominium;
      case DwellingTypeCode.Townhouse:
        return app.ResidenceType.Townhouse;
      case DwellingTypeCode.Duplex:
        return app.ResidenceType.Duplex;
      case DwellingTypeCode.Triplex:
        return app.ResidenceType.Triplex;
      case DwellingTypeCode.Fourplex:
        return app.ResidenceType.Fourplex;
      case DwellingTypeCode.MobileHome:
        return app.ResidenceType.MobileHome;
      default:
        console.warn('Unhandled case', propertyDetail.attributes.dwellingType);
        break;
    }
  }
  return undefined;
}

export function getSquareFootage(propertyDetail: PropertyDetail): number {
  // TODO: This is predicted value, not actual value. Need to check if calculation makes sense with response
  const range = propertyDetail.attributes.squareFootageRange;
  const average = (range.max + range.min) / 2;
  return average;
}
